export enum Role {
    READ = 'ROLE_BACKOFFICE_ADMIN',
    WRITE = 'ROLE_BACKOFFICE_ADMIN_EDIT',
    ADMIN_ACCOUNT = 'ROLE_BACKOFFICE_ADMIN_ACCOUNT',
}

